if (!customElements.get('product-offers')) {
  customElements.define(
    'product-offers',
    class ProductOffers extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.classList.add('is-enhanced');

        const visibleCount = Number.parseInt(this.dataset.visibleCount, 10) || 2;
        this.querySelectorAll('[data-offer-item]').forEach((item, index) => {
          item.classList.toggle('is-extra-offer', index >= visibleCount);
        });

        this.querySelector('[data-offers-toggle]')?.addEventListener('click', (event) => {
          const expanded = this.classList.toggle('is-expanded');
          event.currentTarget.setAttribute('aria-expanded', String(expanded));
          event.currentTarget.querySelector('[data-more-label]').hidden = expanded;
          event.currentTarget.querySelector('[data-less-label]').hidden = !expanded;
        });

        this.addEventListener('click', (event) => {
          const copyButton = event.target.closest('[data-copy-code]');
          if (!copyButton) return;

          event.preventDefault();
          this.copyCode(copyButton.dataset.copyCode, copyButton);
        });
      }

      async copyCode(code, button) {
        try {
          await navigator.clipboard.writeText(code);
          const label = button.querySelector('[data-copy-label]') || button;
          const originalLabel = Array.from(label.childNodes);
          label.textContent = 'Copied';
          this.querySelector('[data-copy-status]').textContent = `Coupon code ${code} copied.`;

          window.setTimeout(() => {
            label.replaceChildren(...originalLabel);
          }, 1800);
        } catch (error) {
          window.prompt('Copy this coupon code:', code);
        }
      }
    }
  );
}
